<template>
    <b-card class="progress-card-compact">
        <!-- Priority Stats Row -->
        <div class="stats-row mb-3">
            <div 
                v-for="priority in priorityDefinitions" 
                :key="priority.value"
                class="stat-item"
                :style="getPriorityStatStyle(priority)"
            >
                <i :class="'fa ' + priority.icon" :style="{ color: priority.color }"></i>
                <span class="stat-number">{{ getPriorityCount(priority.value) }}</span>
                <span class="stat-text">{{ priority.label }}</span>
            </div>
            <div class="stat-item stat-total">
                <i class="fa fa-list"></i>
                <span class="stat-number">{{ summary.total_plans || 0 }}</span>
                <span class="stat-text">Total</span>
            </div>
        </div>

        <!-- Progress Bar -->
        <div class="progress-compact mb-2">
            <div 
                class="progress-segment" 
                :style="{ width: progressPercentage + '%', background: '#10B981' }"
            ></div>
        </div>

        <!-- Progress Text -->
        <div class="d-flex justify-content-between align-items-center">
            <div class="text-dark small font-weight-bold">
                {{ withEndDateCount }} de {{ summary.total_plans || 0 }} con fecha de vencimiento asignada
            </div>
            <div class="text-muted small">{{ withoutEndDateCount }} sin fecha</div>
        </div>
    </b-card>
</template>

<script>
export default {
    name: "ActionPlanPriorityProgress",
    props: {
        summary: {
            type: Object,
            required: true,
            default: () => ({
                total_plans: 0,
                with_end_date: 0,
                priority_alto: 0,
                priority_medio: 0,
                priority_bajo: 0
            })
        },
        priorityDefinitions: {
            type: Array,
            default: () => [
                { value: 'Alto', label: 'Alto', color: '#DC2626', bg_color: '#FEE2E2', text_color: '#991B1B', icon: 'fa-arrow-up' },
                { value: 'Medio', label: 'Medio', color: '#F59E0B', bg_color: '#FEF3C7', text_color: '#92400E', icon: 'fa-minus' },
                { value: 'Bajo', label: 'Bajo', color: '#22C55E', bg_color: '#D1FAE5', text_color: '#065F46', icon: 'fa-arrow-down' }
            ]
        }
    },
    computed: {
        withEndDateCount() {
            return this.summary.with_end_date || 0;
        },
        withoutEndDateCount() {
            return (this.summary.total_plans || 0) - this.withEndDateCount;
        },
        progressPercentage() {
            if (!this.summary.total_plans) return 0;
            return Math.round((this.withEndDateCount / this.summary.total_plans) * 100);
        }
    },
    methods: {
        getPriorityCount(priorityValue) {
            const keyMap = {
                'Alto': 'priority_alto',
                'Medio': 'priority_medio',
                'Bajo': 'priority_bajo'
            };
            const key = keyMap[priorityValue];
            return this.summary[key] || 0;
        },
        getPriorityStatStyle(priority) {
            return {
                background: 'white',
                border: '1px solid ' + priority.color,
                borderLeft: '3px solid ' + priority.color
            };
        }
    }
};
</script>

<style scoped>
.progress-card-compact {
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
}

.progress-card-compact >>> .card-body {
    padding: 0.75rem 1rem;
}

.stats-row {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    flex-wrap: wrap;
}

.stat-item {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 12px;
    border-radius: 6px;
    background: #f8f9fa;
    flex: 1;
    min-width: 100px;
}

.stat-item i {
    font-size: 1.2rem;
}

.stat-number {
    font-size: 1.1rem;
    font-weight: bold;
}

.stat-text {
    font-size: 0.85rem;
    color: #666;
}

.stat-total {
    background: white;
    border: 1px solid #6366F1;
    border-left: 3px solid #6366F1;
}

.stat-total i {
    color: #6366F1;
}

.progress-compact {
    display: flex;
    height: 8px;
    border-radius: 4px;
    overflow: hidden;
    background: #f5f5f5;
}

.progress-segment {
    transition: width 0.3s ease;
    border-radius: 4px;
}

@media (max-width: 768px) {
    .stats-row {
        gap: 6px;
    }
    
    .stat-item {
        flex: 0 0 calc(50% - 3px);
        min-width: auto;
        padding: 6px 8px;
    }
    
    .stat-item.stat-total {
        flex: 0 0 100%;
    }
    
    .stat-item i {
        font-size: 1rem;
    }
    
    .stat-number {
        font-size: 1rem;
    }
    
    .stat-text {
        font-size: 0.75rem;
    }
}
</style>
